"use client";

import { useFeatureFlagEnabled, usePostHog } from "posthog-js/react";
import { useEffect, useRef } from "react";
import { buttonClass } from "@/components/ui/button";

/** Sole switch for this link: ENABLED = renders, absent/DISABLED = today's page. */
export const JOBDETAIL_EMPLOYER_LINK_FLAG = "jobdetail-employer-brief-link";

/**
 * Distribution into the employer hub from the job detail page (~645 human
 * persons/7d vs ~20/7d on the hub). Offers the free brief to a hiring visitor;
 * seekers are never asked to pay. Client island because the page is
 * edge-cached. Off/absent renders nothing.
 */
export function JobDetailEmployerLink({ locale }: { locale: "id" | "en" }) {
	const enabled = useFeatureFlagEnabled(JOBDETAIL_EMPLOYER_LINK_FLAG) === true;
	const posthog = usePostHog();
	const viewedRef = useRef(false);
	const isId = locale === "id";

	useEffect(() => {
		if (!enabled || viewedRef.current) return;
		viewedRef.current = true;
		posthog?.capture("jobdetail_employer_link_viewed", { locale });
	}, [enabled, posthog, locale]);

	if (!enabled) return null;

	return (
		<section
			aria-label={isId ? "Untuk perekrut" : "For employers"}
			data-testid="jobdetail-employer-link"
			className="mt-6 flex flex-col gap-3 rounded-xl border border-border bg-card p-4 sm:flex-row sm:items-center sm:justify-between"
		>
			<p className="text-sm text-foreground">
				{isId
					? "Sedang merekrut posisi serupa? Kirim brief gratis dan kami cocokkan dengan kandidat dari pool kami."
					: "Hiring for a similar role? Send a free brief and we will match it to candidates from our pool."}
			</p>
			<a
				href={`/${locale}/employers?src=job_detail#start`}
				data-testid="jobdetail-employer-cta"
				onClick={() =>
					posthog?.capture("jobdetail_employer_link_clicked", { locale })
				}
				className={buttonClass({ size: "sm", variant: "secondary" })}
			>
				{isId ? "Isi brief gratis" : "Send a free brief"}
			</a>
		</section>
	);
}
